<template>
  <div class="corpo">
    <transition name="pagina">
      <router-view></router-view>
    </transition>
    <loading/>
  </div>
</template>

<script>
import Loading from '@/components/shared/loading/Loading';
require('es6-object-assign/auto');

export default {
  components: {
    'loading' : Loading,
  }
}
</script>

<style>
 
</style>




// WEBPACK FOOTER //
// src/App.vue